<div
  class="avenue-asset-recorder-container"
  id="container"
  fxLayout="column"
  fxLayoutAlign="center center"
  >
  @if (isSecureOrigin && !isChromeIpadUser) {
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      >
      <video #video class="media-player" playsinline autoplay muted></video>
      @if (showOverlay) {
        <div id="overlay">
          <div class="timer">{{ countdownTimer }}</div>
        </div>
      }
      @if (!errorMsg) {
        <div fxLayout="row wrap">
          @if (!isRecording) {
            <button
              mat-raised-button
              color="default"
              (click)="recordingCountdownDelay()"
              >
              <mat-icon>videocam</mat-icon>
              Record
            </button>
          }
          @if (isRecording) {
            <button
              mat-raised-button
              color="default"
              (click)="stopRecording()"
              >
              <mat-icon>videocam_off</mat-icon>
              Stop
            </button>
          }
        </div>
      }
    </div>
  }

  <div>
    @if (errorMsg) {
      <span class="error-msg">{{ errorMsg }}</span>
    }
  </div>
</div>
